import { ChevronDownIcon, ChevronUpDownIcon, ChevronUpIcon } from "components/icons/solid";
import { Sort } from "hooks/useSortToggler";

interface TableSortIconProps<T> {
    sort?: Sort;
    sortBy?: T[keyof T];
    field: T[keyof T];
}

export const TableSortIcon = <T,>({ sort, sortBy, field }: TableSortIconProps<T>) => {
    if (sortBy !== field) {
        return (
            <ChevronUpDownIcon className="h-4 w-4 text-white opacity-0 group-hover:opacity-100" />
        );
    }

    if (sort === "asc") {
        return <ChevronUpIcon className="h-4 w-4 text-white" />;
    } else {
        return <ChevronDownIcon className="h-4 w-4 text-white" />;
    }
};
